/* eslint-disable no-useless-rename */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Route } from 'react-router-dom';
import Auth from "./Auth";

const PrivateRoute = ({ component: Component, type: type, ...rest }) => {
    return (
        <Route {...rest} render={props => {
            return (
                <Auth type={type} Component={Component} p={props} />
            )
        }} />
    );
}

export default PrivateRoute;